import { EventTrackOptions } from "@/src/sb/components/Analytics/AnalyticsAdapter"
import { links } from "@/src/sb/constants/copy/auth"
import Image from "next/legacy/image"
import { useRouter } from "next/router"
import { SyntheticEvent, useState } from "react"

import { pages } from "../../constants/copy"
import Button from "../Button"
import { SearchInput } from "../Input"
import Logo from "../Logo"
import { SimpleLink } from "../SimpleLink"
import Spinner from "../icon/Spinner"
import { MobileTopNavBarProps } from "./types"

const BUTTON_PROPS = {
  loggedIn: { text: "Home", href: links.home },
  subscriber: { text: "", href: "" },
  anonymous: { text: "Sign in", href: pages.signin }
}

const MobileTopNavBar = (props: MobileTopNavBarProps) => {
  const router = useRouter()
  const {
    onSearchChange,
    searchText,
    loading = false,
    userType,
    showSearch = false,
    showActionBtn = true,
    onSearch,
    onNavItemClick,
    actionText,
    actionHref,
    actionBtnType = "primary"
  } = props
  const [showSearchInput, setShowSearchInput] = useState(false)
  const toggleSearchBtn = () => {
    setShowSearchInput(!showSearchInput)
  }

  const buttonProps = BUTTON_PROPS[userType]

  if (actionText) buttonProps.text = actionText
  if (actionHref) buttonProps.href = actionHref

  const handleSearch = (e: SyntheticEvent) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    const searchText = formData.get("q") as string
    router.query.q = searchText
    router.pathname = pages.search
    onSearch?.(searchText)

    router.push(router)
  }

  const navItemClick =
    (name: string, props?: EventTrackOptions["eventProperties"]) => () => {
      onNavItemClick?.(name, props)
    }

  const actionBtnVisible = showActionBtn && buttonProps.text

  const justifyCSS =
    userType === "subscriber" ? "justify-center" : "justify-between"
  return (
    <div>
      <div
        className={`bg-stears_white flex items-center ${justifyCSS} h-full min-h-[60px] w-full pr-4 shadow-sm shadow-[#0000001a]`}
      >
        <SimpleLink
          href={pages.landingPage}
          color="black"
          onClick={() => navItemClick("logo", { context: "header" })}
        >
          <Logo type="black" />
        </SimpleLink>
        <div className="flex items-center ">
          {!loading && actionBtnVisible && (
            <div className="mr-2 text-[12px] ">
              <Button
                type={actionBtnType}
                href={buttonProps?.href}
                pill
                onClick={navItemClick(
                  `${buttonProps.text?.toLowerCase()}_button`,
                  {
                    context: "header"
                  }
                )}
              >
                {buttonProps.text}
              </Button>
            </div>
          )}

          {loading && actionBtnVisible && <Spinner />}

          {showSearch && !showSearchInput && (
            <button
              onClick={toggleSearchBtn}
              type="button"
              aria-label="search"
              className="cursor-pointer flex items-center h-full px-2 py-2"
            >
              <Image
                src="/assets/icons/search-3.svg"
                height={16}
                width={16}
                alt="search"
              />
            </button>
          )}
        </div>
      </div>

      <div
        className="h-[60px]"
        style={{ display: showSearchInput ? "block" : "none" }}
      >
        <form action={pages.search} className="h-full" onSubmit={handleSearch}>
          <SearchInput
            onChange={onSearchChange}
            mode="gray"
            name="q"
            value={searchText}
            onClear={toggleSearchBtn}
            alwaysShowClearIcon={showSearch}
          />
        </form>
      </div>
    </div>
  )
}

export default MobileTopNavBar
